import {Observable, switchMap} from "rxjs";
import {CacheItem} from "./CacheItem";
import {HttpClient} from "@angular/common/http";
import {CachingService} from "./caching.service";


export class CacheText extends CacheItem {
  constructor(cachingService: CachingService, httpClient: HttpClient, url: string, folder: string, proxyUrl: string) {
    super(cachingService, httpClient, url, folder, proxyUrl);
  }

  getBody(response: Response): Promise<any> {
    return response.text();
  }

  getData(body): any {
    return body;
  }
}
